<template>
  <div
    class="navItemWrapper"
    :class="{ valid: isValid }"
  >
    <!-- Main item -->
    <el-menu-item
      :disabled="disabled"
      class="navItem"
      :class="{ active: selected, valid: isValid, invalid: !isValid }"
      index="records-tenant"
    >
      <span class="item">
        <md-icon name="person" />
        <span>{{ $t('records.nav.tenants') }}</span>
      </span>
    </el-menu-item>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NavRecordsInterface from './NavRecordsInterface'

export default {
  name: "NavRecordsTenant",
  extends: NavRecordsInterface,
  computed: {
    ...mapState({
      tenants: state => state.recordsPeople.currentRecordTenants
    }),
    isValid() {
      return this.tenants.length > 0 && this.tenants.reduce((p, n) => p & !!n.confirmed_at, true)
    }
  }
}
</script>
